"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageViewInitializer = void 0;
var _constants = require("../../../constants");
const pageViewInitializer = item => {
  // Disable automatic `pageView` tracking to prevent `pageView` from being sent multiple times
  // when using @ori/logger multiple times on the same page, e.g. in Client Apps.
  if (item.baseType === 'PageviewData' && item.data?.[_constants.TRACK_THIS_PAGE_VIEW] != null) {
    return false;
  }
  return true;
};
exports.pageViewInitializer = pageViewInitializer;
